import React from 'react'
import { IoClose } from 'react-icons/io5'
import AdminCustomButton from '../Button/AdminCustomButton'
import MessageBox from '../../../components/MessageBox'

const AdminInfoBox = ({ modelClose, closeAction, confirmAction, hideCloseBtn, confirmText, heading, message }) => {
    return (
        <div class={`modal packageModel  fade ${modelClose && 'd-flex align-items-center show'}`} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog w-50" role="document">
                <div className="modal-content rounded-5  theme-bg-color border-0 p-3 ">
                    <div className="modal-body ">
                        <div className='d-flex position-relative '>
                           <p className={`text-center d-block theme-text-color admin-input-title d-block position-relative`}> {message} </p>
                        </div>
                    </div>
                    <div className="modal-footer  border-0">
                        {!hideCloseBtn && <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={() => closeAction()} ><MessageBox text="Cancel" /> </button>}
                        <AdminCustomButton className='px-3 py-1 m-0 ' saveMethod={confirmAction} saveText={confirmText} ></AdminCustomButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminInfoBox